/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Communication/Chatbot': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M25.003 6A2.997 2.997 0 0128 8.997v11.006A2.997 2.997 0 0125.003 23H16l-5.573 5.987a.25.25 0 01-.427-.178V23H6.997A2.997 2.997 0 014 20.003V8.997A2.997 2.997 0 016.997 6zm-.008 2H7.005C6.45 8 6 8.45 6 9.005v10.99C6 20.55 6.45 21 7.005 21H12v3l3-3h9.995C25.55 21 26 20.55 26 19.995V9.005C26 8.45 25.55 8 24.995 8zm-12.26 4.02c.142 0 .256.11.256.253-.002.526.072 1.75.74 2.482.485.533 1.206.792 2.204.792 1.01 0 1.75-.266 2.26-.814.695-.747.803-1.953.815-2.468a.251.251 0 01.255-.246h1.489a.25.25 0 01.256.25c.002.663-.116 2.501-1.351 3.827-.897.963-2.15 1.451-3.724 1.451-1.58 0-2.822-.49-3.696-1.459-1.21-1.34-1.267-3.173-1.245-3.828a.25.25 0 01.255-.24h1.486z"/>'
  }
})
